import Image from "next/image";
import { useContext, useRef, useMemo } from "react";
import { GlobalContext } from "../../stores/use_global_state";
import UploadProgress from "./ProgressBar/UploadProgress";

function FilePreview({ style, trim_start, trim_duration }) {
	const videoRef = useRef();

	const { state } = useContext(GlobalContext);
	const Preview = useMemo(() => {
		const checkTimeStamp = () => {
			if (videoRef.current && trim_duration) {
				if (videoRef.current.currentTime > trim_start && videoRef.current.currentTime < trim_start + trim_duration) {
					return;
				} else {
					videoRef.current.currentTime = trim_start;
				}
			}
		};

		return (
			<div className={`${style.video} ${style.adaptive_off}`}>
				<video ref={videoRef} playsInline autoPlay loop muted onTimeUpdate={checkTimeStamp} poster={URL.createObjectURL(state.video)}>
					<source src={URL.createObjectURL(state.video)} type="video/mp4" />
				</video>
			</div>
		);
	}, [state.video, trim_start, trim_duration, style]);

	return Preview;
}

export default function VideoUpload({ style, trim_start, trim_duration, isTrim, dictionary, progress }) {
	return (
		<>
			<div className={`${style.left} ${style.video_upload}`}>{isTrim === "done" && <FilePreview style={style} trim_start={trim_start} trim_duration={trim_duration} />}</div>

			<UploadProgress progress={progress} dictionary={dictionary} isAdaptive={true} />

			<div className={`${style.right}`}>
				<div className={style["included"]}>
					<h3 className={style["included-title"]}>{dictionary["loading_header"]}</h3>
					<div className={style["included-wrapper"]}>
						<div className={style["included-item"]}>
							<Image className={style["included-item__icon"]} src="/remove_back/included/music.png" alt="alert" width="60" height="60" />
							<div className={style["included-item__text"]}>{dictionary["loading_descriptior1"]}</div>
						</div>
						<div className={style["included-item"]}>
							<Image className={style["included-item__icon"]} src="/remove_back/included/library.png" alt="alert" width="60" height="60" />
							<div className={style["included-item__text"]}>{dictionary["loading_descriptior2"]}</div>
						</div>
						<div className={style["included-item"]}>
							<Image className={style["included-item__icon"]} src="/remove_back/included/filters.png" alt="alert" width="60" height="60" />
							<div className={style["included-item__text"]}>{dictionary["loading_descriptior3"]}</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
